<template>
  <v-container>
    <back-btn />
    <v-row>
      <v-col lg="12">
        <v-card class="card--shadow">
          <v-card-text>
            <div v-if="patient" class="d-flex mb-2">
              <p v-if="patient.name" class="subtitle-1 patient-info">
                Name - {{ patient.name }}
              </p>
              <p
                v-if="patient.treatment_startdate != null"
                class="ml-3 subtitle-1 patient-info"
              >
                Code - {{ patient.reg_unique_code }}
              </p>
            </div>
            <div v-if="eachFamilyMember && eachFamilyMember.id" class="d-flex mb-2">
              <p v-if="patient.name" class="subtitle-1 patient-info">
              Family Member Name - <strong> {{ eachFamilyMember.name }}</strong>
              </p>
            </div>
            <v-simple-table v-if="Array.isArray(familyMemberCi) && familyMemberCi.length">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Screening Person</th>
                  <th>Symptom Screening</th>
                  <th>Refer</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ci, index) in familyMemberCi" :key="ci.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ ci.date }}</td>
                  <td>{{ ci.type=='1'?'Community':'Contact' }}</td>
                  <td>{{ ci.screening_person=='1'?'Volunteer':'FO'}}</td>
                  <td>{{ ci.symptom_screening=='1'?'No':'Yes' }}</td>
                  <td>{{ ci.refer=='1'?'No':'Yes' }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <div v-else class="text-center py-4">
              No CI records found.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    BackBtn
  },
  created() {
    this.$store.dispatch("FamilyMember/getEachCi", this.$route.params.id);
    this.$store.dispatch("FamilyMember/getEach", this.$route.params.id).then(() => {
      if (this.eachFamilyMember && this.eachFamilyMember.patient_id) {
        this.$store.dispatch("Patient/getPatient", this.eachFamilyMember.patient_id);
      }
    });
  },
  computed: {
    ...mapState("FamilyMember", ["familyMemberCi"]),
    ...mapGetters("FamilyMember", ["eachFamilyMember"]),
    ...mapState("Patient", ["patient"])
  }
};
</script>

<style scoped>
.patient-info {
  letter-spacing: 1px !important;
}
</style>